import { ajaxSend } from 'api/api';
const v1BasePath = '/v1/tags';
const v2BasePath = '/v2/tags';
export function getTags(params = {}) {
    return ajaxSend({
        path: `${v2BasePath}/conversation`,
        params: params,
    });
}
export function getTagsByName(tagIds) {
    const request = {
        path: `${v2BasePath}/conversation?names=${tagIds.join()}`,
    };
    return ajaxSend(request);
}
export function removeTag(tagId) {
    return ajaxSend({
        method: 'DELETE',
        path: `${v1BasePath}/conversation/${tagId}`,
    });
}
export function createTag(tag) {
    const { name, color } = tag;
    return ajaxSend({
        method: 'POST',
        path: `${v1BasePath}/conversation`,
        data: {
            name: name,
            color: color,
        },
    });
}
export function activateTag(tagId) {
    return ajaxSend({
        method: 'PATCH',
        path: `${v1BasePath}/${tagId}/activate`,
    });
}
export function deactivateTag(tagId) {
    return ajaxSend({
        method: 'PATCH',
        path: `${v1BasePath}/${tagId}/deactivate`,
    });
}
